// 定义一个统一的访问方法
var currentConfig = {}; // 默认空配置（兜底用）
/**
 * 获取当前环境的 __IMAGEX_CONFIG__
 */
export function getGlobalConfig() {
    if (typeof window !== 'undefined') {
        return window.__IMAGEX_CONFIG__;
    }
    if (typeof global !== 'undefined') {
        return global.__IMAGEX_CONFIG__;
    }
    if (typeof getApp !== 'undefined') {
        var app = getApp ? getApp() : {};
        if (app.globalData) {
            return app.globalData.__IMAGEX_CONFIG__;
        }
    }
    return currentConfig; // 直接返回当前缓存的配置
}
/**
 * 设置当前环境的全局变量
 * @param {Object} config - 要设置的配置
 */
export function setGlobalConfig(config) {
    currentConfig = config || {}; // 更新缓存
    try {
        // 根据环境动态挂载到对应的全局变量
        if (typeof window !== 'undefined') {
            // Web 环境：挂载到 window
            window.__IMAGEX_CONFIG__ = config;
        }
        else if (typeof global !== 'undefined') {
            // Node.js 环境：挂载到 global
            global.__IMAGEX_CONFIG__ = config;
        }
        else if (typeof getApp !== 'undefined') {
            // 小程序环境：挂载到 App 实例
            var app = getApp ? getApp() : {};
            if (app.globalData) {
                app.globalData.__IMAGEX_CONFIG__ = config; // 推荐挂载到 globalData
            }
        }
        return true;
    }
    catch (error) {
        return false;
    }
}
